import {
  createComponentExtension,
  createPlugin,
} from '@backstage/core-plugin-api';

export const dhDockHomepagePlugin = createPlugin({
  id: 'dh-dock-homepage',
});

export const DhDockHomepage = dhDockHomepagePlugin.provide(
  createComponentExtension({
    name: 'DhDockHomepage',
    component: {
      lazy: () =>
        import('./components/DhDockHomepage').then(
          module => module.DhDockHomepage,
        ),
    },
  }),
);
